import { render } from "./CardBody.vue?vue&type=template&id=4f416c88"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__